import { ComponentProps } from 'react'

import { PinInput } from '@cash-web/shared-feature-form'

import { BaseBlocker } from '../BaseBlocker/BaseBlocker'

export type BlockerPasscodeEntryProps = {
  length: number
  name: string
  onSubmit: (passcode: string) => void
} & Omit<ComponentProps<typeof BaseBlocker>, 'onSubmit'>

export const BlockerPasscodeEntry = ({ length, name, onSubmit, buttons = [], ...rest }: BlockerPasscodeEntryProps) => {
  return (
    <BaseBlocker onSubmit={onSubmit} buttons={buttons} {...rest}>
      <PinInput name={name} pinLength={length} onComplete={onSubmit} />
    </BaseBlocker>
  )
}
